import React from 'react'
import { Redirect, Switch } from 'react-router-dom'

import { ROUTE_URLS } from 'router/routes'

import { UpgamingSportPages } from 'shared/models/Upgaming'

export function createRoutes(modules) {
  const routesFromModules = modules.map(module => module.getRoutes())
  return (
    <>
      <Switch>
        <Redirect exact from="/" to={ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME)} />
        <Redirect exact from="/main" to={ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME)} />
        <Redirect exact from="/casino" to={ROUTE_URLS.SLOTS('casino')} />
        {routesFromModules}
      </Switch>
    </>
  )
}
